export default __webpack_public_path__ + "fb0f4ca1ce6a2f10bc67c815af9d8e57.svg";